<template>
  <FullScreenLoader :open="lPerformingUpgrade">
    <span>Processing...</span>
  </FullScreenLoader>

  <UModal v-model="upgradeSuccessfulModalOpen" prevent-close>
    <UpgradeBannerUpgradeSuccessfulModal @close="handleFinishUpgrade">
      <slot name="succesful-upgrade-content" />
    </UpgradeBannerUpgradeSuccessfulModal>
  </UModal>

  <UModal v-model="upgradeFailedModalOpen" prevent-close>
    <UpgradeBannerUpgradeErrorModal
      :error="lUpgradeError"
      @close="upgradeFailedModalOpen = false"
    />
  </UModal>
</template>

<script setup>
  defineOptions({
    name: "OneClickUpgradeInterface",
  })

  const props = defineProps({
    performingUpgrade: {
      type: Boolean,
      default: false,
    },
    upgradeResult: {
      type: Boolean,
      default: false,
    },
    upgradeError: {
      type: String,
      default: "",
    },
    finishUpgrade: {
      type: Function,
      required: false,
    },
  })

  const upgradeSuccessfulModalOpen = ref(false)
  const upgradeFailedModalOpen = ref(false)

  const lPerformingUpgrade = ref(props.performingUpgrade)
  const lUpgradeError = ref(props.upgradeError)

  watch(
    [
      () => props.performingUpgrade,
      () => props.upgradeResult,
      () => props.upgradeError,
    ],
    ([newPerformingUpgrade, newUpgradeResult, newUpgradeError]) => {
      lPerformingUpgrade.value = newPerformingUpgrade
      lUpgradeError.value = newUpgradeError

      if (!newPerformingUpgrade && newUpgradeResult) {
        upgradeSuccessfulModalOpen.value = true
      } else if (!newPerformingUpgrade && newUpgradeError) {
        upgradeFailedModalOpen.value = true
      }
    },
  )

  const userStore = useUserStore()
  const handleFinishUpgrade = async () => {
    upgradeSuccessfulModalOpen.value = false
    upgradeFailedModalOpen.value = false

    await userStore.refetchUser()

    if (props.finishUpgrade) {
      await props.finishUpgrade()
    }
  }
</script>
